<template>
  <div>
    <hr class="separador_amplio">
    <footer class="footer" id="footer">
        <div class="footer__contacto">
           <p class="contacto descripcion">
                Centro de Investigación en Modelos de Gestión y Sistemas Informáticos "CIMOGSYS"
           </p> 
        </div>

        <div class="footer__links">
            <router-link class="opciones__item" v-bind:to="'/about/TerminosUso'" > 
              Términos de Uso |</router-link>
          
          <router-link class="opciones__item" v-bind:to="'/about/AcercaDe'" > 
              Acerca De |</router-link>
          <router-link class="opciones__item" v-bind:to="'/about/TerminosUso'" > 
              Créditos |</router-link>

          <router-link class="opciones__item" v-bind:to="'/about/Ayuda'" > 
              Ayuda |</router-link>
          

          <router-link class="opciones__item" v-bind:to="'/login'" v-if="!login" @click.prevent="logOut"> 
              Login </router-link>

          <div class="opciones__item logeo" v-if="login">
             <router-link class="opciones__item" v-bind:to="'/gestion'" @click.prevent="logOut"> Panel |</router-link>
          </div>
          <div class="opciones__item logeo" v-if="login"  @click.prevent="logOut">
             <router-link class="opciones__item" v-bind:to="'/gestion'">Log Out </router-link> 
          </div>
       

        </div>
    </footer>
  </div>
</template>

<script>

import store from '../store'

  export default {
      data: function(){
          return {
          }
      },
    computed: {
        menuActive () {
          return store.state.menuActive
        }, 
        login () {
          return store.state.login
        },

    },
    methods:{
      updateStateMenu () {
        store.commit('UPDATEMENU')
      },
      logOut () {
        store.commit('LOGOUT')
        this.$router.push('/')
      }
     
       
    }
      
}
</script>

<style lang="scss" scoped src="../sass/pie.scss"></style>


// WEBPACK FOOTER //
// src/components/pie.vue